// extracted by mini-css-extract-plugin
export var header = "index-module--header--cviCf";
export var headerWithAnnouncement = "index-module--headerWithAnnouncement--KhoBw";
export var sticky = "index-module--sticky--1kM4W";
export var stickyLogoMobile = "index-module--stickyLogoMobile--9LL80";
export var stickyLogo = "index-module--stickyLogo--1cHU7";
export var logoHeight = "index-module--logoHeight--2Y9Wb";
export var stickyLinks = "index-module--stickyLinks--3Le9d";
export var stickyRight = "index-module--stickyRight--1MZw1";